import React from 'react';
import cx from 'classnames';
import { Portal } from 'react-portal';
import { NavLink } from 'react-router-dom';
import styles from './NavigationOverlay.module.scss';
import withClickAnalytics from '../../enchancers/with-click-analytics';

const menuItemAnalyticsOptions = {
  category: 'menu',
  defaultAction: 'select',
};

function Link({ ...props }) {
  return <a {...props} />;
}

const TrackedLink = withClickAnalytics(menuItemAnalyticsOptions)(Link);
const TrackedRouterLink = withClickAnalytics(menuItemAnalyticsOptions)(NavLink);

const NavigationOverlay = ({ show, onLinkFollow }) => (
  <Portal>
    <div className={cx(styles.root, { [styles.root_show]: show })}>
      <nav className={styles.nav}>
        <TrackedLink href="/" analyticsLabel="home" className={styles.link} onClick={onLinkFollow}>
          Homepage
        </TrackedLink>

        <TrackedRouterLink
          to="/infographics"
          exact
          analyticsLabel="infographics"
          className={styles.link}
          activeClassName={styles.link_active}
          onClick={onLinkFollow}
        >
          Infographics
        </TrackedRouterLink>
      </nav>
    </div>
  </Portal>
);

export default NavigationOverlay;
